import React from 'react';
import * as ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import { manageDataReducer } from './ManageStore';
import { themeDataReducer, configDataReducer, labelsReducer } from './ThemeStore';
import { selectionReducer } from './LevelSelection';
import thirdpartyReducer from '../reducers/manage/thirdparty';
import { searchReducer } from '../reducers/manage/search';
import serviceHealthReducer from '../reducers/serviceHealth';
import {
    modalPropertyHelpReducer,
    modalPropertyReducer,
    modalThemeAndConfigHelpReducer,
    modalThemeAndConfigReducer,
    modalSaveReducer,
    modalContentInfoReducer,
    // eslint-disable-next-line import/named
    modalGuestInfoReducer,
    modalConfirmationSettingsReducer,
    modalLabelSettingsReducer,
    modalGenericPropertyValuesReducer
} from '../components/modals/AllModal';
import sabreJsonReference from '../../mocks/reference_Trust.json';
import {inContextThemeReducer} from './InContextThemeStore';

const modalReducer = combineReducers({
    propertyHelp: modalPropertyHelpReducer,
    property: modalPropertyReducer,
    themeAndConfigHelp: modalThemeAndConfigHelpReducer,
    themeAndConfig: modalThemeAndConfigReducer,
    save: modalSaveReducer,
    contentInfo: modalContentInfoReducer,
    guestInfo: modalGuestInfoReducer,
    confirmationInfo: modalConfirmationSettingsReducer,
    labelsInfo: modalLabelSettingsReducer,
    genericPropertyValues: modalGenericPropertyValuesReducer
});

const appDefaults = {
    initialData: { manage: { manage: {} } }
};

const saveStateActions = {};

const appInitialStateReducer = (state = appDefaults, action) => {
    switch (action.type) {
        case 'persist/REHYDRATE':
            // In case of a reload set initialData.theme as changes to
            // mocks/reference_Trust.json are not reflected in redux!
            // If you sign in the theme is set in next switch case
            // with ActionTypes.APP_SAVE_INITIAL_DATA
            // To test this change "themes[0].name" in "../../mocks/reference_Trust.json"
            if (!state.initialData.theme) {
                const val = Object.assign({}, state);
                val.initialData.theme = sabreJsonReference;
                return val;
            }
            return state;
        case ActionTypes.APP_SAVE_INITIAL_DATA:
            // This action is called after successfully login only! -> NOT ON A RELOAD!
            if (action.payload) {
                const dataToSave = {
                    config: action.payload
                };
                // Temporary add sabreJsonReference to the store
                // FIXME:
                // The mock data will not be used if the server sends the data!
                if (!action.payload.theme) {
                    dataToSave.theme = sabreJsonReference;
                } else {
                    // save theme json data from server:
                    dataToSave.theme = action.payload.theme;
                }
                return Object.assign({}, state, {
                    initialData: dataToSave
                });
            }
            return state;
        default:
            return state;
    }
};

const leftnavStateReducer = (state = { collapsed: false }, action) => {
    switch (action.type) {
        case ActionTypes.LEFT_NAV_TOGGLE:
            return {
                collapsed: !state.collapsed
            };
        case ActionTypes.LEFT_NAV_SHOW:
            return {
                collapsed: false
            };
        case ActionTypes.LEFT_NAV_HIDE:
            return {
                collapsed: true
            };
        default:
            return state;
    }
};

const appReducer = combineReducers({
    data: combineReducers({
        configuration: configDataReducer,
        labels: labelsReducer,
        manage: manageDataReducer,
        theme: themeDataReducer,
        thirdparty: thirdpartyReducer,
        inContextTheme: inContextThemeReducer
    }),
    referenceState: appInitialStateReducer,
    modal: modalReducer,
    selected: selectionReducer,
    leftMenu: leftnavStateReducer,
    search: searchReducer,
    serviceHealth: serviceHealthReducer
});

export { appReducer, saveStateActions };



// WEBPACK FOOTER //
// ./src/store/AppStore.js